export { default } from "./HeroContent";
